import { Document, Page, StyleSheet, View, Text, Font } from '@react-pdf/renderer';
import { InvoiceHeader } from '../Header';
import { InvoiceItems } from '../InvoiceItems';
import { InvoiceFooter } from '../Footer';
import { InvoiceClientDto } from '../../../commonTypes/client.types';
import { OrganizationWithPolicies } from '../../../commonTypes/organization.types';
import { InvoiceDto } from '../../../commonTypes/invoice.types';

Font.register({
    family: 'Satoshi',
    fonts: [
        { src: require('../../../assets/fonts/Satoshi-Regular.otf'), fontWeight: 400 },
        { src: require('../../../assets/fonts/Satoshi-Medium.otf'), fontWeight: 500 },
        { src: require('../../../assets/fonts/Satoshi-Italic.otf'), fontStyle: 'italic' },
    ],
});

const styles = StyleSheet.create({
    page: {
        padding: 32,
        fontFamily: 'Satoshi',
        fontSize: 10,
        lineHeight: 1.4,
    },
    notesAndTermsSection: {
        position: 'absolute',
        bottom: 70,
        left: 32,
        width: '60%',
        padding: 16,
        paddingBottom: 0,
    },
    noteText: {
        fontSize: 11,
        color: '#676F80',
        lineHeight: 1.6,
        marginBottom: 8,
    },
    termsText: {
        fontSize: 11,
        color: '#676F80',
        lineHeight: 1.6,
    },
});

type InvoicePDFProps = {
    items: {
        title: string;
        subtitle: string;
        quantity: string;
        rate: string;
        tax: string;
        amount: string;
    }[];
    subtotal: string;
    tax: string;
    total: string;
    amountDue: string;
    invoice: Partial<InvoiceDto>;
    organization?: OrganizationWithPolicies;
    client: InvoiceClientDto;
};

export const InvoicePDF = ({ items, subtotal, tax, total, amountDue, invoice, organization, client }: InvoicePDFProps) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <InvoiceHeader
                invoiceNumber={invoice.number}
                invoiceDate={invoice.invoiceDate}
                dueDate={invoice.dueDate}
                totalAmount={total}
                organization={organization}
                client={client}
            />
            <InvoiceItems items={items} subtotal={subtotal} tax={tax} total={total} amountDue={amountDue} />
            {(invoice.notes?.trim() !== '' || invoice.termsAndConditions?.trim() !== '') && (
                <View style={styles.notesAndTermsSection}>
                    {invoice.notes && <Text style={styles.noteText}>{invoice.notes}</Text>}
                    {invoice.termsAndConditions && <Text style={styles.termsText}>Terms & Conditions: {invoice.termsAndConditions}</Text>}
                </View>
            )}
            <InvoiceFooter organization={organization} />
        </Page>
    </Document>
);
